import InvestmentInfoPanel from './InvestmentInfoPanel';

export default InvestmentInfoPanel;
